import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

type SectionLabelProps = {
  children: ReactNode;
  icon?: ReactNode;
  className?: string;
};

/** Eyebrow chip s hairline pill (13 px uppercase, tracking 0.14em). */
export function SectionLabel({ children, icon, className }: SectionLabelProps) {
  return (
    <span
      className={cn(
        "eyebrow inline-flex items-center gap-2 rounded-full border border-[var(--color-hairline)] px-3.5 py-1.5",
        className,
      )}
    >
      {icon}
      {children}
    </span>
  );
}
